// TODO: CHECKOUT-9979 remove this file before delivery
/**
 * Dev-only credentials. DO NOT use in production code paths.
 * Activated only when the `enableB2bDevMode` URL param is present.
 */
export const B2B_DEV_MODE_URL_PARAM = 'enableB2bDevMode';
export const B2B_DEV_MODE_APP_CLIENT_ID = 'dl7c39mdpul6hyc489yk0vzxl6jesyx';
export const B2B_DEV_MODE_BASE_URL = 'https://api-b2b.bigcommerce.com';
